// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customer-swiper-wrapper {
    max-width: 414px;
    height: 100%;
}

.customer-indicator-wrapper {
    margin-top: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 5px;
}

.customer-indicator-item {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.4);
    margin-right: 8px;
}

.customer-indicator-item-active {
    background-color: white;
}
`, "",{"version":3,"sources":["webpack://./../client/page/detail/views/content/components/CouponHomePop/index.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,0CAA0C;IAC1C,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;AAC3B","sourcesContent":[".customer-swiper-wrapper {\n    max-width: 414px;\n    height: 100%;\n}\n\n.customer-indicator-wrapper {\n    margin-top: 10px;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding-left: 5px;\n}\n\n.customer-indicator-item {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background-color: rgba(255, 255, 255, 0.4);\n    margin-right: 8px;\n}\n\n.customer-indicator-item-active {\n    background-color: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
